import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import "./switchToggle.css"; // Asegúrate de que esta hoja de estilos maneje el nuevo switch

const SwitchToggle = ({ label, labelInstruction, name, value1, value2 }) => {
  const {
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();
  const toggleValue = watch(name);
  const isActive =
    toggleValue === t("formulario_rubrica_campo_placeholder_comentario_si");

  useEffect(() => {
    const defaultValue = t(
      "formulario_rubrica_campo_placeholder_comentario_no",
    );
    if (!isActive) {
      setValue(name, defaultValue);
    }
  }, [name, setValue, isActive, t]);

  const handleToggle = () => {
    const newValue = !isActive
      ? t("formulario_rubrica_campo_placeholder_comentario_si")
      : t("formulario_rubrica_campo_placeholder_comentario_no");
    setValue(name, newValue);
  };

  return (
    <div className="input-text">
      {label && <label className="input-label">{label}</label>}
      {labelInstruction && (
        <label className="input-instruction">{labelInstruction}</label>
      )}
      <div className="flex flex-row items-center gap-2 px-4">
        <span className="font-bold text-Grey-500">{value1}</span>
        <div className="toggle-form-switch" onClick={handleToggle}>
          <div
            className={`switch-indicator ${isActive ? "switch-indicator-active" : ""}`}
          ></div>
        </div>
        <span className="font-bold text-Grey-500">{value2}</span>
      </div>
      {errors[name] && <p className="text-error">{errors[name].message}</p>}
    </div>
  );
};

export default SwitchToggle;
